import { render } from "./ClientSettingsVoting.vue?vue&type=template&id=e4b22944&scoped=true"
import script from "./ClientSettingsVoting.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientSettingsVoting.vue?vue&type=script&charset=utf-8&lang=js"

import "./ClientSettingsVoting.vue?vue&type=style&index=0&id=e4b22944&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b22944"]])

export default __exports__